import React from 'react';

import styles from './NewsArticle.module.css';

type TProps = {
  children: React.ReactNode;
};

export const NewsArticleInfo = ({ children }: TProps) => (
  <div className={styles.NewsArticle__Info}>{children}</div>
);
